import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'take-picture',
  templateUrl: './take-picture.component.html'
})
export class TakePictureComponent implements OnInit {
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef | undefined;

  @Input()
  titleBtn = 'PHOTO_TAKE';

  @Input()
  isDisabled = false;

  @Input()
  isWide = false;

  @Output()
  photoChange: EventEmitter<Blob> = new EventEmitter<Blob>();

  constructor() {
  }

  ngOnInit(): void {
  }

  onPhotoChange(event: any): void {
    const blob: Blob = event && event.target.files[0] ? event.target.files[0] : null;
    this.photoChange.emit(blob);

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  onTakePhoto(): void {
    this.fileInput?.nativeElement.click();
  }
}
